export default __webpack_public_path__ + "static/media/location.6aabcf16.svg";